const ErrorMessages = {
    PlaceHolder: '',
    UnAuthorized: 'You are unauthorized to access this resource',
    RequiredField: '',
    InValidEmailAddressFormat: '',
    BadRequest: '',
    ODataException: '',
    FailedToSendEmail: '',
    InsufficientPasswordComplexity: '',
    BadPassword: '',
    DatabaseError: 'Error updating the database',
    EntityNotFound: '',
    EntityExists: '',
    ResourceNotFound: '',
    PasswordResetFail: '',
    InvalidEnumValue: '',
    InvalidValue: 'A required field is missing or invalid',
    DocumentValidation: '',
    ResourceInUse: '',
    UnsupportedMediaType: '',
    DocumentCancelError: '',
    DocumentResendError: '',
    ActionNotAllowed: '',
    RequestTimeout: '',
    EntityCreation: '',
    EntityUpdateFail: '',
    FileCreationFailed: '',
    WorkflowEngineProcessingTimeout: '',
} as const;

export default ErrorMessages;
